var map = {
	"./boom.js": "12db",
	"./clearanceManagement.js": "fdad",
	"./commoditySales.js": "4c1f4",
	"./common.js": "cfc6",
	"./configurationCenter.js": "4e47",
	"./dataBoard.js": "a19e",
	"./dataImport.js": "92b8",
	"./giftsManagement.js": "35d3",
	"./goods.js": "56a3",
	"./goodsAnalysis.js": "5a93",
	"./intelligentRecom.js": "dd3e",
	"./jd.js": "45f2",
	"./newProduct.js": "8777",
	"./orderDate.js": "f984",
	"./pack.js": "3ad8",
	"./preSalePlan.js": "a59e",
	"./product.js": "460c",
	"./productLifeCycle.js": "fd0c",
	"./productModelDetails.js": "436b",
	"./qualityTestingManage.js": "e4ae",
	"./refundManagement.js": "b638",
	"./returnManagement.js": "5a47",
	"./sheet.js": "7f04",
	"./shortVideoOverview.js": "1af0",
	"./smallHomeAppliances.js": "6adf",
	"./smallPieceManagement.js": "06b6",
	"./spu.js": "353c",
	"./storeData.js": "97ec",
	"./suite.js": "d753",
	"./user.js": "43b5",
	"./wanjia.js": "6e65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";